import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
    padding: spacing(24, 8, 8),
  },
  title: {
    fontSize: spacing(16),
    color: Theme.Colors.Grayscale.Eighty,
  },
  divider: {
    margin: spacing(8, 0),
  },
  radioGroupStyles: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
  },
  labelInputRadioButton: {
    marginLeft: '0px',
    marginRight: '0px',
    gap: '6px',
  },
  strong: {
    color: Theme.Colors.Grayscale.Eighty,
  },
}))
